<div class="card">
    <div class="card-body" [ngClass]="{'e-bigger': isMobileView}">
        <ejs-grid #grid [dataSource]='data' [query]='query' [editSettings]="editSettings" [toolbar]="toolbar"
            [enableAdaptiveUI]="isMobileView" [rowRenderingMode]="isMobileView ? 'Vertical' : 'Horizontal'"
            [columns]='columns' (actionBegin)='actionBegin($event)' (actionComplete)='actionComplete($event)'            
            [pageSettings]='pageOptions'  allowPaging='true' allowSorting='true' allowFiltering="true"
            [sortSettings]="sortSettings" [filterSettings]='filterSettings'>
            <ng-template #createdOnTemplate let-data>
                <div class="row text-wrap">
                    <app-get-date-time [dateTime]="data.CreatedOn"></app-get-date-time>
                </div>
            </ng-template>
            <ng-template #editionTmpl let-data>
                {{ data.EditionId == 1 ? 'Silver' : data.EditionId == 2 ? 'Gold' : data.EditionId == 3 ? 'Auditor' : '' }}
            </ng-template>
            <ng-template #editSettingsTemplate let-data>
                <div [formGroup]="formData">
                    <div class="row">
                        <div class="form-group col-lg-12">
                            <ejs-autocomplete id='AccountId' 
                                [ngClass]="{'e-error': f.AccountId.invalid && submitClicked}"
                                [allowCustom]="false" [dataSource]='accountData' formControlName="AccountId"
                                name="AccountId" [query]="accountQuery" [fields]='{text:"Name", value:"Id"}'
                                placeholder='Account Name' [showPopupButton]="true"
                                (filtering)="onFiltering($event,'a')"
                                floatLabelType="Always"></ejs-autocomplete>
                                @if((f.AccountId.invalid && submitClicked) 
                                || (f.AccountId.invalid && submitClicked)){
                                    <div id="AccountIdError">
                                    <label class="e-error" for="AccountId" id="AccountId-info" style="display: block;">
                                        *Account can not be empty</label>
                                </div>
                                }
                            
                        </div>
                    </div>

                    <div class="row ">
                        <app-mte-input class="col-md-6 col-sm-10" type="number" label="Serial No" [control]="f.SerialNo"
                        [isRequired]="true"></app-mte-input>
                        <div class="form-group col-lg-6 col-sm-12">
                            <ejs-datepicker formControlName="ExpiryDate" name="ExpiryDate" placeholder='Expiry Date'
                                class="required"  [min]='minDate' floatLabelType='Always' [format]='"dd-MMM-yyyy"'>
                            </ejs-datepicker>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="form-group col-lg-6  col-sm-12">
                            <ejs-autocomplete id='EditionId'
                                [ngClass]="{'e-error': f.EditionId.invalid && submitClicked}"
                                [allowCustom]="false" [dataSource]='editionData' formControlName="EditionId"
                                name="EditionId" [fields]='{text:"Name", value:"Id"}' placeholder='Edition'
                                [showPopupButton]="true" floatLabelType="Always"></ejs-autocomplete>
                                @if((f.EditionId.invalid && submitClicked) 
                                || (f.EditionId.invalid && submitClicked)) {
                                    <div id="EditionIdError">
                                        <label class="e-error" for="EditionId" id="EditionId-info" style="display: block;">
                                            *Edition can not be empty</label>
                                    </div>
                                }
                            
                        </div>
                        <app-mte-input class="col-md-6 col-sm-10" label="Remarks" [control]="f.Remarks"
                                ></app-mte-input>
                    </div>
                </div>
            </ng-template>
        </ejs-grid>
    </div>
</div>